/** XeAgents.ai **/
import { FollowUpQueueView } from "@/components/campaigns/FollowUpQueueView";

export default function FollowUpQueue() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Follow-up Queue</h1>
        <p className="text-muted-foreground mt-1">
          View and manage all scheduled follow-up calls across campaigns
        </p>
      </div>
      <FollowUpQueueView />
    </div>
  );
}
